export default "https://statics.cloudfastin.top/static/v1.27.34.1/store/images/productTag.png?ad41a1622af0d2d7098cb59ec7e052aa";